/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_View_HistoryInputs */

const en_plan_view_history = /** @type {(inputs: Plan_View_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`History`)
};

const de_plan_view_history = /** @type {(inputs: Plan_View_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verlauf`)
};

/**
* | output |
* | --- |
* | "History" |
*
* @param {Plan_View_HistoryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_view_history = /** @type {((inputs?: Plan_View_HistoryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_View_HistoryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_plan_view_history(inputs)
	return en_plan_view_history(inputs)
});